import { render, staticRenderFns } from "./NewTodoItemType.vue?vue&type=template&id=12420ddb"
import script from "./NewTodoItemType.vue?vue&type=script&lang=js"
export * from "./NewTodoItemType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports